import packageSettings from '../../package.json' assert { type: 'json' };

export function getReleaseVersion(): string {
  return packageSettings.version;
}
